import * as React from 'react';
import * as style from './Position.css';
import classnames from 'classnames';
import { useDeviceType } from '@cian/ui-kit';

interface ITPosition {
  showsPosition: number;
  positionChange: number;
}

export const Position: React.FC<ITPosition> = ({ showsPosition, positionChange }) => {
  const device = useDeviceType();

  return (
    <div
      className={classnames(
        style['item-position-container'],
        device === 'phone' && style['item-position-container-mobile'],
      )}
    >
      {showsPosition}

      {positionChange !== 0 && positionChange !== null && (
        <div
          className={classnames(
            style['change-position'],
            device === 'phone' && style['change-position-mobile'],
            positionChange < 0 ? style['change-position-down'] : style['change-position-up'],
          )}
        >
          {positionChange < 0 ? '↓' : '↑+'}
          {positionChange}
        </div>
      )}
    </div>
  );
};
